"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.masonryGrid = void 0;
const Masonry = require("masonry-layout");
const masonryGrid = () => {
    let grid = document.querySelector('.masonry');
    if (typeof (grid) != 'undefined' && grid != null) {
        var msnry = new Masonry(grid, {
            itemSelector: '.masonry__item',
        });
    }
    let gridMobile = document.querySelector('.masonry-mobile');
    if (typeof (gridMobile) != 'undefined' && gridMobile != null) {
        let msnryMobile;
        function masonryMobileInit() {
            let width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            if (width <= 768 && !msnryMobile) {
                msnryMobile = new Masonry(gridMobile, {
                    itemSelector: '.masonry-mobile__item',
                    fitWidth: true
                });
            }
            else if (width > 768 && msnryMobile) {
                msnryMobile.destroy();
                msnryMobile = null;
            }
        }
        document.addEventListener("DOMContentLoaded", masonryMobileInit);
        window.addEventListener("resize", masonryMobileInit);
    }
};
exports.masonryGrid = masonryGrid;
